const baseURL = 'https://lockerroompe.com';

export default baseURL;
